// removed by extract-text-webpack-plugin
module.exports = {"feadbackForm":"feadbackForm__feadbackForm--2IHY4","row":"feadbackForm__row--37Ork","req":"feadbackForm__req--l7WQj","inputBox":"feadbackForm__inputBox--213Zr","note":"feadbackForm__note--1r43E","ContactInfo":"feadbackForm__ContactInfo--3ddZY","inputContainer":"feadbackForm__inputContainer--FPV7s","Input":"feadbackForm__Input--3LTUR","Label":"feadbackForm__Label--3vNbs","buttonMenu":"feadbackForm__buttonMenu--1JnRW","modalDialog":"feadbackForm__modalDialog--3ZtzJ","close":"feadbackForm__close--7gBnt","modalA":"feadbackForm__modalA--1NabN","modalH2":"feadbackForm__modalH2--3d6uS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Feadback Form/feadbackForm.css
// module id = 79
// module chunks = 0